if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.anchorId = this.dataset.buyButtonsAnchor;
        this.button = this.querySelector('[data-sticky-submit]');
        this.buttonText = this.querySelector('[data-sticky-submit-text]');
        this.priceContainer = this.querySelector('[data-sticky-price]');
        this.observer = null;
        this.variantUnsubscribe = null;
      }

      connectedCallback() {
        if (this.button) {
          this.button.addEventListener('click', this.onClick.bind(this));
        }

        const anchor = document.getElementById(this.anchorId);
        if (anchor && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const visible = entries[0].isIntersecting;
              this.toggle(!visible);
            },
            { rootMargin: '0px 0px -20% 0px', threshold: 0 }
          );
          this.observer.observe(anchor);
        } else {
          this.toggle(true);
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
            this.updateFromHtml(event.data.html);
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (typeof this.variantUnsubscribe === 'function') this.variantUnsubscribe();
      }

      toggle(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-active', visible);
      }

      onClick(event) {
        event.preventDefault();
        const target = document.getElementById(this.anchorId);
        if (!target) return;
        if (target.hasAttribute('disabled')) return;
        target.click();
      }

      updateFromHtml(html) {
        if (!html) return;

        const newPrice = html.getElementById(`price-${this.sectionId}`);
        if (newPrice && this.priceContainer) {
          this.priceContainer.innerHTML = newPrice.innerHTML;
        }

        const newButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (newButton && this.button) {
          const disabled = newButton.hasAttribute('disabled');
          this.button.toggleAttribute('disabled', disabled);
          const newText = newButton.querySelector('span');
          if (newText && this.buttonText) {
            this.buttonText.textContent = newText.textContent.trim();
          }
        }
      }
    }
  );
}
